export const Sepia = (intensity: number) => (srcData: any) => {
  const mix = Math.max(0, Math.min(1, intensity / 100)); // normalize 0-100 to 0-1
  const data = srcData.data;
  const len = data.length;

  for (let i = 0; i < len; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    // Sepia transformation matrix
    const sepiaR = r * 0.393 + g * 0.769 + b * 0.189;
    const sepiaG = r * 0.349 + g * 0.686 + b * 0.168;
    const sepiaB = r * 0.272 + g * 0.534 + b * 0.131;

    // Mix with original based on intensity
    data[i] = Math.min(255, r * (1 - mix) + sepiaR * mix);
    data[i + 1] = Math.min(255, g * (1 - mix) + sepiaG * mix);
    data[i + 2] = Math.min(255, b * (1 - mix) + sepiaB * mix);
    // Alpha remains unchanged
  }
};
